export default __webpack_public_path__ + "media/images/landing-9-550x420-ad3a99660233dfb23d092a1277de1f06.jpg";